import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"

// import { cn } from "@/src/lib/utils"
import { cn } from "../../lib/utils";

const buttonVariants = cva(
  "inline-flex items-center mt-0 text-[#020617] justify-center whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring width-470px disabled:pointer-events-none disabled:opacity-50" ,
  {
    variants: {
      variant: {
        default:
         "bg-blue-500 text-white shadow hover:bg-blue-600", // Change to blue
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
        outline:
          "border border-input bg-background shadow-sm hover:bg-accent hover:text-accent-foreground",
        secondary:
          "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
        ghost: "hover:bg-accent hover:text-accent-foreground",
        link: "text-primary underline-offset-4 hover:underline",
        
      },
      size: {
        default: "h-9 px-4 py-2 w-80", // Full width
        sm: "h-8 rounded-md px-3 text-xs w-48", // Fixed width
        lg: "h-10 rounded-md px-8 w-80", // Larger fixed width
        icon: "h-9 w-9",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}  
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }
